import { useEffect, useState } from 'react'

import Api from 'services/api'
import { Sessions, Session } from 'types/RemoteConfig'

const useRemoteConfigSessions = () => {
  const [sessions, setSessions] = useState<Session[] | null>(null)

  useEffect(() => {
    setSessions([])

    const poll = () => {
      Api.RemoteConfig.list(['pending', 'accepted', 'denied', 'active', 'stopped'])
        .then((res: Sessions) => {
          setSessions(res.sessions)
        }).catch(() => {
          setSessions([])
        })
    }

    poll()

    const pollInterval = setInterval(poll, 60 * 1000) // poll once a minute

    return () => clearInterval(pollInterval)
  }, [])

  return { sessions }
}

export default useRemoteConfigSessions
